import React from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/fontawesome-pro-regular'

const CloseButton = ({ onClick }) => {
  return (
    <a
      type='button'
      onClick={onClick}
      data-ext='close-button-splunk-on-call-banner'
      className='btn btn--close-splunk-on-call-banner'
    >
      <FontAwesomeIcon icon={faTimes} />
    </a>
  )
}

export default CloseButton
